import React from 'react'
import { FiCalendar, FiMail, FiPhone } from 'react-icons/fi'
import PropTypes from 'prop-types';

DrSidebars.propTypes = {
    email: PropTypes.string,
    phone1: PropTypes.string,
    image: PropTypes.string,
    ctaurl: PropTypes.string,
    ctaicon: PropTypes.string,
};

export default function DrSidebars({ email = '', phone1 = '', image = '', ctaurl = '', ctaicon = '' }) {
    function formatPhoneNumber(phone) {
        // Remove all non-digit characters
        const digits = phone.replace(/\D/g, '');
        // Format if length is at least 10
        if (digits.length >= 10) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
        }
        return phone;
    }
    return (
        <>
            <div className="card bg-white p-4 rounded shadow sticky-bar">
                <div>
                    <img src={image} className="img-fluid w-100 rounded mb-2" alt="" />
                    {ctaurl && (
                        <div className='text-center'>
                            <a href={ctaurl} target='_blank' rel="noreferrer" className="btn btn-secondary w-100 btn-sm my-2 mx-auto text-center">
                                <FiCalendar fontSize={'2em'} />
                                <span> Agendar Cita</span>
                            </a>
                        </div>
                    )}
                    {email && (
                        <div className='text-center'>
                            <a href={`mailto:${email}`} className="btn btn-primary w-100 btn-sm my-2 mx-auto text-center">
                                <FiMail fontSize={'2em'} />
                                <span> Contactar</span>
                                <br />
                                <span className='text-muted text-lowercase'>{email}</span>
                            </a>
                        </div>
                    )}
                    {phone1 && (
                        <div className='text-center'>
                            <a href={`tel:${phone1}`} className="btn btn-success w-100 btn-sm my-2 mx-auto text-center">
                                <FiPhone fontSize={'2em'} />
                                <span> Llamar</span>
                                <br />
                                <span className='text-light text-lowercase'>{formatPhoneNumber(phone1)}</span>
                            </a>
                        </div>
                    )}
                    <br />
                </div>
            </div>
        </>
    )
}
